import { defaultConfig, defineLayerStyles } from '@chakra-ui/react';

const layerStyles = defineLayerStyles({
    ...defaultConfig.theme?.layerStyles,
    'card.surface': {
        description: 'card styles',
        value: {
            background: { base: 'bg', _dark: 'bg.subtle' },
            padding: '2',
        },
    },
    'card.muted': {
        description: 'muted card styles',
        value: {
            background: 'bg.muted',
            padding: '2',
            borderRadius: 'md',
        },
    },
});

export { layerStyles };
